/** 缺省引导方式 */
export const DEFAULT_BOOT_MODE = 'PXE';

/**
 * 解析引导方式选项：config.bootOptions 非空则用其值，否则仅 PXE。
 */
export function resolveBootOptions(bootOptions?: string[] | null): string[] {
  if (!Array.isArray(bootOptions)) return [DEFAULT_BOOT_MODE];
  const cleaned = bootOptions.map((item) => String(item ?? '').trim()).filter(Boolean);
  return cleaned.length ? cleaned : [DEFAULT_BOOT_MODE];
}

/** 默认选中：列表含 PXE 则 PXE，否则第一项 */
export function resolveDefaultBootMode(bootOptions?: string[] | null): string {
  const options = resolveBootOptions(bootOptions);
  return options.includes(DEFAULT_BOOT_MODE) ? DEFAULT_BOOT_MODE : options[0];
}
